import locale from "@bonliva-crm/locale";
import { Button, Modal } from "@bonliva-crm/ui";
import { ComponentProps, useEffect, useState } from "react";
import { CustomerFullSearch, CustomerFullSearchValue } from "./customer-full-search";

type Props<IsMulti extends boolean> = {
  open: boolean;
  setOpen: (open: boolean) => void;
  instantSelection?: IsMulti extends true ? never : boolean;
} & ComponentProps<typeof CustomerFullSearch<IsMulti>>;

export { CustomerFullSearchValue };

export const CustomerFullSearchModal = <IsMulti extends boolean>(
  props: Props<IsMulti>
) => {
  const {
    open,
    setOpen,
    instantSelection,
    onChange: _onChange,
    value: _value,
    ...rest
  } = props;

  // Used to trigger the onChange upon clicking add button, instead of on selection
  const [intermediaryValue, setIntermediaryValue] = useState<typeof props.value>(
    props.value
  );

  // If we've updated the value from the outside, update the intermediary value to reflect this
  useEffect(() => {
    if (
      !instantSelection &&
      Array.isArray(props.value) &&
      Array.isArray(intermediaryValue) &&
      props.value.length !== intermediaryValue.length
    ) {
      setIntermediaryValue(props.value);
    }
  }, [props.value]);

  const onChange = (value: typeof props.value) => {
    if (instantSelection) {
      setOpen(false);
      _onChange(value);
    } else {
      setIntermediaryValue(value);
    }
  };

  const value = instantSelection ? _value : intermediaryValue;

  const onClose = () => {
    setIntermediaryValue(props.value);
  };

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      modalContent={
        <CustomerFullSearch
          {...rest}
          value={value}
          onChange={onChange}
          instantSelection={instantSelection}
        />
      }
      onClose={onClose}
      label={locale.ChooseField(locale.Customer.toLowerCase())}
      labelSubtitle="Välj en kund genom att söka efter dess namn eller genom att fylla i dess
      kundnummer. Du kan även filtrera på olika kundgrupper."
      rightCta={
        <>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => {
              setOpen(false);
              onClose();
            }}
          >
            {locale.Cancel}
          </Button>
          {!instantSelection && (
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                setOpen(false);
                _onChange(intermediaryValue);
              }}
              disabled={Array.isArray(value) ? value.length === 0 : !value}
            >
              {locale.Add}
            </Button>
          )}
        </>
      }
      dimensions={{
        minHeight: "80%",
        height: "90vh",
        minWidth: "50vw",
        width: "50vw"
      }}
    ></Modal>
  );
};
